/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as transactionService from '../services/transactionService'
import MarketOrderModel from './sub_components/marketOrderModel'
import * as userService from '../services/userService'
import Autocomplete from 'react-autocomplete';
import Currency from './sub_components/currency'
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import * as _ from 'lodash'
import * as dateUtil from '../util/date.util'
import { BASE_IMAGE_PATH } from '../configs/api';
import SinglePageUnderMaintenance from './singlePageUnderMaintenance';
let linkClickTimeout
let printClickTimeout
class TransactionsReports extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         user_id: '',
         usersList: [],
         client_id: "",
         accounts: '',
         types: "ALL",
         gameTypes: "ALL",
         transactions_data: [],
         csv_json: [],
         pdf_json: [],
         transactions_search_data: [],
         last_id: "",
         first_id: "",
         action: "",
         from: "",
         to: "",
         page_no: 1,
         count_records: 0,
         opening_balance: 0,
         closing_balance: 0,
         records_display: 25,
         current_balance: 0,
         hst_balance: 0,
         hst_id: "",
         toastMsg: "",
         toastType: "",
         showData: false,
         loader: false,
         total_page: 1,
         market_id: "",
         onShowOrderPopup: false
      };
   }
   async componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if(!(!!userData && !!userData.sub)){
         localStorage.clear();
         this.props.history.push("/auth")
      }
      this.setState({ user_id: userData.sub })
      let curDate = new Date(Date.now()).setSeconds(0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ to: curDate, from: weekDate })
   }
   componentWillUnmount(){
      clearTimeout(linkClickTimeout)
      clearTimeout(printClickTimeout)
   }
   parseToPickerDate(date) {
      let dtArr = date.split("/")
      let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
      return dt
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   parseFilterBody() {
      // let body = {
      //    "filters": {
      //       "user_ids": this.state.user_id,
      //       "types": this.state.types,
      //       "gameTypes": this.state.gameTypes,
      //       "client_ids": this.state.client_id
      //    },
      //    "last_id": this.state.last_id,
      //    "first_id": this.state.first_id,
      //    "action": this.state.action,
      //    "from": new Date(this.state.from).toISOString(),
      //    "to": new Date(this.state.to).toISOString(),
      //    "zone": new Date().getTimezoneOffset(),
      //    "page_no": this.state.page_no,
      //    "count_records": this.state.count_records,
      //    "opening_balance": this.state.page_no !== 1 ? this.state.opening_balance : 0,
      //    "closing_balance": this.state.closing_balance,
      //    "records_display": this.state.records_display,
      //    "current_balance": this.state.current_balance,
      //    "hst_balance": this.state.hst_balance
      // }
      let body = {   
       
         "filters":{
             "types": this.state.types,
             "gameTypes": this.state.gameTypes,
             "userId": this.state.client_id
         },
         "lastId": this.state.last_id,
         "firstId": this.state.first_id,
         "closingBalance": this.state.closing_balance,
         "hstId": this.state.hst_id,
         "hstBalance": this.state.hst_balance,
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
         "openingBalance": this.state.page_no !== 1 ? this.state.opening_balance : 0,
         "action": this.state.action,
         "pageNo": this.state.page_no,
         "countRecords": this.state.count_records,
         "recordsPerPage": this.state.records_display
     }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      this.setState({ loader: true, showData: false })
      transactionService.postTransaction2(body).then((res) => {
         if (res.isSuccess) {
            self.setState(
               {
                  transactions_data: [],
                  transactions_search_data: [],
                  last_id: res.lastId,
                  first_id: res.firstId,
                  action: res.action,
                  page_no: res.pageNo,
                  count_records: res.countRecords,
                  opening_balance: 0.00,
                  closing_balance: 0.00,
                  current_balance: res.currentBalance,
                  hst_balance: 0,
                  hst_id: "",
                  total_page: 1,
                  showData: true,
               }, () => {
                  let closing_bal = res.openingBalance;
                  let curr_user;
                  if (this.state.accounts !== "") {
                     curr_user = this.state.accounts
                  } else {
                     curr_user = this.state.user_id
                  }
                  for (let smt of res.items) {
                     if (smt.creditAccount === curr_user) {
                        closing_bal -= smt.amount
                     } else {
                        closing_bal += smt.amount
                     }
                  };
                  self.setState({
                     opening_balance: res.openingBalance,
                     closing_balance: closing_bal,
                     transactions_data: res.items,
                     transactions_search_data: res.items,
                     hst_balance: res.hstBalance,
                     hst_id: res.hstId,
                     total_page: Math.ceil(res.countRecords / this.state.records_display),
                     loader: false
                  })
               }
            );
         } else {
            this.setState({ transactions_data: [], transactions_search_data: [], showData: true, loader: false, last_id: "", first_id: "", action: "", page_no: 1, hst_balance: 0, hstId: "", count_records: 0, current_balance: 0, opening_balance: 0, closing_balance: 0 })
         }
      })
   }
   async onDownload() {
      const self = this;
      this.setState({ csv_json: [] }, () => {
         let trans = this.state.transactions_search_data
         let dictinory = {}
         let balance = this.state.opening_balance
         let items = []
         let filter_user_id = !!this.state.client_id ? this.state.client_id : this.state.user_id
         dictinory["Date"] = ""
         dictinory["Credit"] = ""
         dictinory["Debit"] = ""
         dictinory["Closing"] = Math.round((balance + Number.EPSILON) * 100) / 100
         dictinory["Description"] = "Opening Balance"
         dictinory["From → To"] = ""
         items.push(dictinory)
         for (let x of trans) {
            dictinory = {}
            let st = x["createdAt"].split(" ")
            let dtstr = st[0] + "T" + st[1] + ".000+00:00"
            let dt = new Date(dtstr).toLocaleString("hi-IN")
            dictinory["Date"] = dt
            if (x["creditAccount"] === filter_user_id) {
               dictinory["Credit"] = x["amount"]
               dictinory["Debit"] = "-"
               balance += Math.round((x["amount"] + Number.EPSILON) * 100) / 100
            }
            if (x["debitAccount"] === filter_user_id) {
               dictinory["Credit"] = "-"
               dictinory["Debit"] = x["amount"]
               balance -= Math.round((x["amount"] + Number.EPSILON) * 100) / 100
            }
            dictinory["Closing"] = Math.round((balance + Number.EPSILON) * 100) / 100
            dictinory["Description"] = x["description"]
            if (x["type"] !== "BALANCE" && x["type"] !== "COMMISSION") {
               if (x["creditAccount"] === "CASH_" + filter_user_id) {
                  let credit_account = x["tags"][1]
                  dictinory["From → To"] = x["debitAccount"] + " → " + credit_account
               }
               else if (x["debitAccount"] === "CASH_" + filter_user_id) {
                  let debit_account = x["tags"][1]
                  dictinory["From → To"] = debit_account + " → " + x["creditAccount"]
               }
               else {
                  dictinory["From → To"] = x["debitAccount"] + " → " + x["creditAccount"]
               }
            }
            else {
               dictinory["From → To"] = ""
            }
            items.push(dictinory)
         }
         this.setState({ csv_json: items }, () => {
            linkClickTimeout = setTimeout(function () {
               self.csvLink.current.link.click();
            }, 500)

         })
      })
   }
   async onPDFDownload() {
      this.setState({ pdf_json: [] }, () => {
         this.setState({ pdf_json: this.state.transactions_search_data }, () => {
            printClickTimeout = setTimeout(function () {
               printJS({
                  printable: 'printJS-div',
                  type: 'html',
                  targetStyles: ['*']
               })
            }, 500)
         })
      })
   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   onShowOrderPopup(market_id) {
      this.setState({ onShowOrderPopup: true, market_id: market_id })
   }
   onHideOrderPopup() {
      this.setState({ onShowOrderPopup: false, market_id: "" })
   }
   resetForm() {
      let curDate = new Date(Date.now()).setSeconds(0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ types: "ALL", gameTypes: "ALL", from: weekDate, to: curDate, accounts: "", total_page: 1, usersList: [], client_id: "", showData: false, transactions_data: [], transactions_search_data: [], last_id: "", first_id: "", action: "", page_no: 1, hst_balance: 0, count_records: 0, current_balance: 0, opening_balance: 0, closing_balance: 0, records_display: 25 })
   }
   onSubmit(e) {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 31) {
         this.props.notify("Date range must be 1 month.", "error");
      }
      else {
         this.setState({ action: "", page_no: 1, accounts: this.state.client_id, opening_balance: 0, first_id: "" }, () => { this.submitForm(); });
      }
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "records_display") {
         this.setState({ [name]: value, page_no: 1, first_id: "", opening_balance: 0, action: "" }, () => { this.submitForm(); });
      }
      else if (name === "types") {
         this.setState({ [name]: value, gameTypes: "ALL" });
      }
      else {
         this.setState({ [name]: value });
      }
   }
   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.user_id, value)
         let lst = []
         // for (let x of res.usersList) {
         //    lst.push({ label: x, value: x, title: x, name: x })
         // }
         for(let i = 0; i < res.usersList.length; i++){
            const pushobj = { label: res.usersList[i], value: res.usersList[i], title: res.usersList[i], name: res.usersList[i] }
            let indx = lst.length;
            if(i === 0){
               lst.push(pushobj);
            } else {
               for(let j = 0; j < lst.length; j++){
                  if(lst[j].value.toLowerCase() > pushobj.value.toLowerCase()){
                     indx = j;
                     break;
                  }
               }

               lst.splice(indx, 0, pushobj);
            }
         }
         // lst.sort(function(a, b) {
         //     if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
         //     if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
         //     return 0;
         // });
         this.setState({ usersList: lst })
      }
      else {
         this.setState({ [name]: value, usersList: [] })
      }
   }
   onAction(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "page_no") {
         this.setState({ [name]: parseInt(value), last_id: "", action: "", first_id: "" }, () => { this.submitForm(); });
      }
      if (name === "last") {
         this.setState({ page_no: this.state.total_page, last_id: "", action: "", first_id: "", opening_balance: 0 }, () => { this.submitForm(); });
      }
      else if (name === "first") {
         this.setState({ action: name, last_id: "", first_id: "", opening_balance: 0, page_no: 1 }, () => { this.submitForm(); });
      }
      else if (name === "prev" || name === "next") {
         this.setState({ action: name }, () => { this.submitForm(); });
      }
   }
   onPagination() {
      let lst = []
      let total_page = this.state.total_page
      for (let x = 1; x <= total_page; x++) {
         if (this.state.page_no === x || Math.abs(x - this.state.page_no) <= 2 || (this.state.page_no < 3 && x < 6) || (total_page - this.state.page_no < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.page_no === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"accstate_btn_" + x} name="page_no" value={x} onClick={(e) => { this.onAction(e) }}>{x} </button>
            lst.push(htm)
         }
      }
      return lst
   }
   onDateTimeChange(name, e) {
      this.setState({ [name]: e._d, hst_balance: 0 })
   }
   onSearch(e) {
      const value = e.target.value;
      let transactions_lst = []
      if (this.state.transactions_search_data) {
         transactions_lst = _.filter(this.state.transactions_search_data, function (obj) {
            return JSON.stringify(obj).toLowerCase().indexOf(value.toLowerCase()) !== -1;
         });
         this.setState({ transactions_data: [] }, () => {
            this.setState({ transactions_data: transactions_lst })
         });
      };
   }
   render() {
      let page_no = parseInt(this.state.page_no)
      let count_records = parseInt(this.state.count_records)
      let records_display = parseInt(this.state.records_display)
      let current_record = 0
      let total_record = 0
      let start_record = 0
      if (count_records > (records_display * page_no)) {
         current_record = records_display * page_no
         total_record = count_records
         start_record = current_record - (records_display - 1)
      } else if (this.state.transactions_data.length > 0) {
         current_record = count_records
         total_record = count_records
         start_record = ((page_no - 1) * records_display) + 1
      }
      let open_bal = this.state.opening_balance
      let pdf_open_bal = this.state.opening_balance
      let curr_user;
      if (this.state.accounts !== "") {
         curr_user = this.state.accounts
      } else {
         curr_user = this.state.user_id
      }
      return (
         <>
            <div className="bethubs">
               <Header history = {this.props.history} />
               <div className="wrapper">
                  <div className="container-fluid container-padding-0">
                     <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                           <div className="main-box">
                              <h5 className="text-blue">Account Statement Report </h5>
                              <div className="row mt-2">
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12">
                                       <select onChange={(e) => { this.onChange(e) }} title="Types" className="form-control" name="types" value={this.state.types}>
                                          <option value="ALL">ALL</option>
                                          <option value="BALANCE">BALANCE REPORT</option>
                                          <option value="GAME">GAME REPORT</option>
                                          <option value="SETTLEMENT">SETTLEMENT REPORT</option>
                                          <option value="BONUS">BONUS REPORT</option>
                                       </select>
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12">
                                       <select onChange={(e) => { this.onChange(e) }} title="Game Types" className="form-control" name="gameTypes" value={this.state.gameTypes}>
                                          <option value="ALL">ALL</option>
                                          {/* {(this.state.types === "BALANCE" || this.state.types === "SETTLEMENT") && <option value="UPLINE">Upper Level</option>}
                                          {(this.state.types === "BALANCE" || this.state.types === "SETTLEMENT") && <option value="DOWNLINE">Down Level</option>} */}
                                          {this.state.types === "GAME" && <option value="Cricket">Cricket</option>}
                                          {this.state.types === "GAME" && <option value="Football">Soccer</option>}
                                          {this.state.types === "GAME" && <option value="Tennis">Tennis</option>}
                                          {this.state.types === "GAME" && <option value="Kabaddi">Kabaddi</option>}
                                          {this.state.types === "GAME" && <option value="Election">Election</option>}
                                          {this.state.types === "GAME" && <option value="LOTUS">Indian Poker</option>}
                                          {this.state.types === "GAME" && <option value="SUPERNOVA">Indian Poker2</option>}
                                          {this.state.types === "GAME" && <option value="DRC">Casino</option>}
                                       </select>
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12 autocomplete-wrapper">
                                       <Autocomplete
                                          value={this.state.client_id}
                                          items={this.state.usersList}
                                          getItemValue={item => item.title}
                                          renderItem={(item, isHighlighted) =>
                                             <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                                {item.title}
                                             </div>
                                          }
                                          inputProps={{ placeholder: 'Search by client' }}
                                          name="client_id"
                                          onChange={(event, client_id) => this.onUserSearch(event, "client_id", client_id)}
                                          onSelect={client_id => this.setState({ client_id })}
                                       />
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12">
                                       <Datetime
                                          value={this.state.from}
                                          onChange={(e) => this.onDateTimeChange("from", e)}
                                          id="from_datetime"
                                          dateFormat={"DD/MM/YYYY"}
                                          timeFormat={"HH:mm"}
                                       />
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12">
                                       <Datetime
                                          value={this.state.to}
                                          onChange={(e) => this.onDateTimeChange("to", e)}
                                          id="to_datetime"
                                          dateFormat={"DD/MM/YYYY"}
                                          timeFormat={"HH:mm"}
                                       />
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                       <button className="btn btn-blue" disabled={!!this.state.from && !!this.state.to ? false : true} onClick={(e) => this.onSubmit(e)}>Go</button>
                                       <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                    </div>
                                 </div>
                              </div>
                              {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}>Loading......</div> : null}
                              {!!this.state.showData && <div>
                                 <div className="row text-center mt-2">

                                    <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 mt-4 order-md-1 order-sm-2 order-2">
                                       <div className="d-flex float-left">
                                          <div className="form-group mb-0 d-inline">
                                             <input className="form-control" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                          </div>
                                          <CSVLink
                                             data={this.state.csv_json}
                                             filename={"MyTransaction-Report.csv"}
                                             asyncOnClick={true}
                                             className="d-none"
                                             ref={this.csvLink}>
                                          </CSVLink>
                                          <button className="btn btn-sm csv-icon d-inline p-0" title="Export Data" onClick={(e) => this.onDownload(e)} disabled={this.state.transactions_data.length > 0 ? false : true}><img alt="" src={BASE_IMAGE_PATH + "/aimg/csv-icon.svg"}></img></button>
                                          <div style={{ display: "none" }}>
                                             <div id="printJS-div">
                                                <table id="exportall" className="table font-12 table-bordered table-sm" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px' }} >
                                                   <thead >
                                                      <tr>
                                                         <th className="text-left pthead rw-150">Date &amp; Time</th>
                                                         <th className="text-right pthead rw-80">Credit</th>
                                                         <th className="text-right pthead rw-80">Debit</th>
                                                         <th className="text-right pthead rw-80">Closing</th>
                                                         <th className="text-left pthead">Description</th>
                                                         <th className="text-left pthead">From &#8594; To</th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      <tr bgcolor="#ffffff">
                                                         <td></td>
                                                         <td className="text-right text-success"></td>
                                                         <td className="text-right text-danger"></td>
                                                         <td className="text-right fbold">{this.state.opening_balance ? <Currency key={"accstatepd_opbal"} className={this.state.opening_balance > 0 ? "text-success fbold" : this.state.opening_balance < 0 ? "text-danger fbold" : "fbold"} amount={this.state.opening_balance} showColor={false} /> : "0.00"}</td>
                                                         <td>Opening Balance </td>
                                                         <td> </td>
                                                      </tr>
                                                      {this.state.pdf_json.length > 0 ? this.state.pdf_json.map((user, i) => {
                                                         let st = (user.createdAt).split(" ")
                                                         let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                         let dt = new Date(dtstr).toLocaleString("hi-IN")
                                                         let debit_account = user.debitAccount
                                                         let credit_account = user.creditAccount
                                                         if (user.credit_account === curr_user) {
                                                            pdf_open_bal += user.amount
                                                         } else {
                                                            pdf_open_bal -= user.amount
                                                         }
                                                         if (user.type === "DEPOSIT") {
                                                            if (credit_account === "CASH_" + curr_user) {
                                                               credit_account = user.tags[1]
                                                            }
                                                            if (debit_account === "CASH_" + curr_user) {
                                                               debit_account = user.tags[1]
                                                            }
                                                         }
                                                         let description = !!user.tags && user.tags.length === 0 ? "-" : user.tags[0] === "BINARY" ? dateUtil.getBinaryDescriptionDisplay(user.description) : user.description
                                                         return (<>
                                                            <tr key={"accstatepd_tr" + i} bgcolor="#ffffff">
                                                               <td className="text-left rw-150" title={dt ? dt : "-"}>{dt ? dt : "-"}</td>
                                                               <td className="text-right">{user.credit_account === curr_user ? <Currency key={"accstatepd_cre_" + i} className="fbold text-green" amount={user.amount} showColor={false} /> : "-"}</td>
                                                               <td className="text-right">{user.debit_account === curr_user ? <Currency key={"accstatepd_deb_" + i} className="fbold text-red" amount={user.amount} showColor={false} /> : "-"}</td>
                                                               <td className="text-right">{pdf_open_bal ? <Currency key={"accstatepd_open_" + i} className="fbold" amount={pdf_open_bal} showColor={true} /> : "0.00"}</td>
                                                               <td className="text-left">{user.tags === null ? "-" : user.tags.length > 2 ?
                                                                        <a className="undline" onClick={(e) => this.onShowOrderPopup(user.tags[1])}>{
                                                                            user.tags[0] === "BINARY" ?
                                                                            <>
                                                                                {description[0]}/{description[1][0]}
                                                                                <span>[Time: <b>{(description[1][1])}</b>]</span>
                                                                                /{description[2]}
                                                                            </>
                                                                             : description
                                                                        }</a> :
                                                                        user.tags[0] === "BINARY" ?
                                                                            <>
                                                                                {description[0]}/{description[1][0]}
                                                                                <span> [Time: <b>{(description[1][1])}</b>]</span>
                                                                                /{description[2]}
                                                                            </>
                                                                             : description
                                                                             }</td>
                                                               <td className="text-left">{(user.type !== "BALANCE" && user.type !== "COMMISSION" && user.type !== "BONUS") ? <>{!!debit_account ? debit_account : "-"} &#8594; {!!credit_account ? credit_account : "-"}</> : ""}</td>
                                                            </tr></>
                                                         );
                                                      }) : <tr>
                                                         <td colSpan={15} align="center">
                                                            No Data Found.
                                             </td>
                                                      </tr>}
                                                   </tbody>
                                                </table>
                                             </div>
                                          </div>
                                          <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(e)} disabled={this.state.transactions_data.length > 0 ? false : true}>
                                             <img alt="" src={BASE_IMAGE_PATH + "/aimg/pdf-icon.svg"}></img>
                                          </button>
                                       </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mb-1 order-md-2 order-sm-1 order-1">
                                       {this.state.user_id !== "" ?
                                          <table className="table table-bordered nowrap table-sm mb-1 opcb mx-0 float-right">
                                             <tbody>
                                                <tr className="w-100">
                                                   <td><span className="d-inline font-12">Opening Balance </span></td>
                                                   <td className="text-right"><span className="fbold d-inline font-12">{!!this.state.closing_balance ? <Currency key={"accstate_open"} className="fbold d-inline font-12" amount={this.state.closing_balance} showColor={true} /> : "0.00"}</span></td>
                                                </tr>
                                                <tr className="w-100">
                                                   <td><span className="d-inline font-12">Closing Balance &nbsp;&nbsp; </span></td>
                                                   <td className="text-right font-12 vbas"><span className="fbold d-inline font-12">{!!this.state.opening_balance ? <Currency key={"accstate_close"} className="fbold d-inline font-12" amount={this.state.opening_balance} showColor={true} /> : "0.00"}</span></td>
                                                </tr>
                                             </tbody>
                                          </table>
                                          : ""}
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 mt-4 order-md-3 order-sm-2 order-3">
                                       <span className="d-inline search-report"> &nbsp; entries</span>
                                       <div className="form-group font-12 float-right mb-0">
                                          <select onChange={(e) => { this.onChange(e) }} className="form-control" name="records_display" value={this.state.records_display}>
                                             <option value="25">25</option>
                                             <option value="50">50</option>
                                             <option value="100">100</option>
                                          </select>
                                       </div>
                                       <span className="d-inline search-report mr-2">Show</span>
                                    </div>
                                 </div>
                                 <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                       <div className="table-responsive">
                                          <table id="example" className="table font-12 table-bordered table-sm addpadding table-striped mt-2">
                                             <thead>
                                                <tr>
                                                   <th className="pthead">Date &amp; Time</th>
                                                   <th className="text-right pthead rw-80">Credit</th>
                                                   <th className="text-right pthead rw-80">Debit</th>
                                                   <th className="text-right pthead rw-80">Closing</th>
                                                   <th className="pthead">Description</th>
                                                   <th className="pthead">From &#8594; To</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                <tr>
                                                   <td></td>
                                                   <td className="text-right text-success"></td>
                                                   <td className="text-right text-danger"></td>
                                                   <td className="text-right fbold">{this.state.opening_balance ? <Currency key={"accstate_opbal"} className={this.state.opening_balance > 0 ? "text-success fbold" : this.state.opening_balance < 0 ? "text-danger fbold" : "fbold"} amount={this.state.opening_balance} showColor={false} /> : "0.00"}</td>
                                                   <td>Closing Balance </td>
                                                   <td> </td>
                                                </tr>
                                                {!!this.state.loader ?
                                                   <tr>
                                                      <td colSpan={15} align="center">
                                                         Loading......
                                                    </td>
                                                   </tr> :
                                                   this.state.transactions_data.length > 0 ? this.state.transactions_data.map((user, i) => {
                                                      let st = (user.createdAt).split(" ")
                                                      let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                      let dt = new Date(dtstr).toLocaleString("hi-IN")
                                                      let debit_account = user.debitAccount
                                                      let credit_account = user.creditAccount
                                                      if (user.creditAccount === curr_user) {
                                                         open_bal -= user.amount
                                                      } else {
                                                         open_bal += user.amount
                                                      }
                                                      if (user.type === "DEPOSIT") {
                                                         if (credit_account === "CASH_" + curr_user) {
                                                            credit_account = user.tags[1]
                                                         }
                                                         if (debit_account === "CASH_" + curr_user) {
                                                            debit_account = user.tags[1]
                                                         }
                                                      }
                                                      let description = !!user.tags && user.tags.length === 0 ? "-" : user.tags[0] === "BINARY" ? dateUtil.getBinaryDescriptionDisplay(user.description) : user.description
                                                      return (<>
                                                         <tr key={"accstatepd_tr" + i}>
                                                            <td title={dt ? dt : "-"}>{dt ? dt : "-"}</td>
                                                            <td className="text-right">{user.creditAccount === curr_user ? <Currency key={"accstate_cre_" + i} className="fbold text-green" amount={user.amount} showColor={false} /> : "-"}</td>
                                                            <td className="text-right">{user.debitAccount === curr_user ? <Currency key={"accstate_deb_" + i} className="fbold text-red" amount={user.amount} showColor={false} /> : "-"}</td>
                                                            <td className="text-right">{open_bal ? <Currency key={"accstate_open_" + i} className="fbold" amount={open_bal} showColor={true} /> : "0.00"}</td>
                                                            <td className="" title={user.description}>
                                                                    {user.tags === null ? "-" : user.tags.length > 2 ?
                                                                        <a className="undline" onClick={(e) => this.onShowOrderPopup(user.tags[1])}>{
                                                                            user.tags[0] === "BINARY" ?
                                                                            <>
                                                                                {description[0]}/{description[1][0]}
                                                                                <span>[Time: <b>{(description[1][1])}</b>]</span>
                                                                                /{description[2]}
                                                                            </>
                                                                             : description
                                                                        }</a> :
                                                                        user.tags[0] === "BINARY" ?
                                                                            <>
                                                                                {description[0]}/{description[1][0]}
                                                                                <span> [Time: <b>{(description[1][1])}</b>]</span>
                                                                                /{description[2]}
                                                                            </>
                                                                             : description
                                                                             }
                                                                </td>
                                                            {/* <td title={user.description}>{!!user.description ? user.tags.length > 2 ? <a className="undline" onClick={(e) => this.onShowOrderPopup(user.tags[1])} >{user.description}</a> : user.description : "-"}</td> */}
                                                            <td>{(user.type !== "BALANCE" && user.type !== "COMMISSION" && user.type !== "BONUS") ? <>{!!debit_account ? debit_account : "-"} &#8594; {!!credit_account ? credit_account : "-"}</> : ""}</td>
                                                         </tr></>
                                                      );
                                                   }) : <tr>
                                                      <td colSpan={15} align="center">
                                                         No Data Found.
                                             </td>
                                                   </tr>}
                                             </tbody>
                                          </table>
                                       </div>
                                       <div className="row">
                                          <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {start_record} - {current_record} of {total_record} entries</span></div>
                                          <div className="col-12 col-sm-12 col-md-6">
                                             <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                                <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" && this.state.page_no === 1 ? true : false}>First</button>
                                                <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" && this.state.page_no === 1 ? true : false}>Prev</button>
                                                {this.onPagination()}
                                                <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" && this.state.page_no === this.state.total_page ? true : false}>Next</button>
                                                <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" && this.state.page_no === this.state.total_page ? true : false}>Last</button>
                                             </div>
                                          </div>
                                       </div>
                                       {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                                    </div>
                                 </div>
                              </div>}

                              {/* maintainance code start */}
                              {/*
                                 <SinglePageUnderMaintenance pageOrReport={'This report'} maintananceDuration={'24 to 48 hours'}></SinglePageUnderMaintenance>
                              */}
                              {/* maintainance code end */}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <Footer />
               {this.state.onShowOrderPopup && <MarketOrderModel user_id={this.state.client_id} current_user={this.state.user_id} market_id={this.state.market_id} hidePopupBets={() => { this.onHideOrderPopup() }} />}
            </div>
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(TransactionsReports);